export const updateProps = (props, key, value) => {
  const newState = {
    ...props
  };
  newState[key].value = typeof value === newState[key].type && (newState[key].type !== "number" || !isNaN(value)) ? value : undefined;
  return newState;
};
//# sourceMappingURL=setPropValue.helper.js.map